import { Document } from '@contentful/rich-text-types'
import { Body, ContentfulRichText } from '@superhi/design'
import React from 'react'

import Hyperlink from '../Hyperlink'

const RICHTEXT_1_NODE_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['nodeOverrides'] =
  {
    paragraph: (_, c) => (
      <Body color="GREY_60" level="3">
        {c}
      </Body>
    ),
    hyperlink: (node, c) => <Hyperlink url={node.data.uri}>{c}</Hyperlink>,
  }

type Props = {
  children: Document
}

const Caption: React.FC<Props> = ({ children }) => (
  <ContentfulRichText nodeOverrides={RICHTEXT_1_NODE_OVERRIDES}>
    {JSON.stringify(children)}
  </ContentfulRichText>
)

export default Caption
